module.exports = __webpack_public_path__ + "img/Schlauchtruppführer.c89184ee.svg";